import React from 'react';
import PropTypes from 'prop-types';

export function SvgReset(props) {
  const { width = 16, height = 16, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <g filter="url(#filter-1)">
          <g stroke={stroke} transform="translate(3 3)">
            <circle cx="5" cy="5" r="5" />
            <path d="M10 5L8 5" />
            <path d="M2 5L0 5" />
            <path d="M5 2L5 0" />
            <path d="M5 10L5 8" />
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgReset.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
